/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionAnswerSelectedOptionIds } from './questionAnswerSelectedOptionIds';
import type { QuestionAnswerTextResponse } from './questionAnswerTextResponse';

/**
 * A user's answer to a ContentStudioQuestion.
 */
export interface QuestionAnswer {
  questionId: string;
  selectedOptionIds?: QuestionAnswerSelectedOptionIds;
  textResponse?: QuestionAnswerTextResponse;
}
